$(".forum-comment__btn").click(function(){
    let comment = $(this).parents(".forum-comment");
    let block = $(this).parents(".forum-comment__main");
    let answer = block.find(".forum-answer");
    if (! answer.length) {
        answer = $(".answer-template").html();
        block.children().hide();
        block.append(answer);
        answer = block.find(".forum-answer");

        let name = comment.find(".forum-comment-author__name").text();
        answer.find(".forum-answer__target").text(name);
    } else {
        block.children().hide();
        answer.show();
    }
})

$("body").on("click", ".forum-answer__btn", function(e){
    // e.preventDefault();
    let answer = $(this).parents(".forum-answer");
    answer.hide();
    answer.siblings().show();
})
